module.exports = __webpack_public_path__ + "img/4.144069f2.svg";